export default {
  methods: {
    quotationStatusColour (status) {
      switch (status) {
        case 'ACCEPTED': return 'green-7'
        case 'REJECTED': return 'red-7'
        case 'DRAFT': return 'grey'
        case 'ARCHIVED': return 'grey-6'
        default:
        case 'SENT': return 'blue-7'
      }
    },
    quotationStatusName (status) {
      switch (status) {
        case 'ACCEPTED': return 'Accepted'
        case 'REJECTED': return 'Rejected'
        case 'DRAFT': return 'Draft'
        case 'ARCHIVED': return 'Archived'
        default:
        case 'SENT': return 'Published'
      }
    },
    quotationStatusOptions (withAll = false, colorKey = 'color', current = null) {
      const arr = [
        { label: 'Published', value: 'SENT', [colorKey]: 'blue' }
      ]
      if (!current || !['ACCEPTED', 'REJECTED'].includes(current)) {
        arr.unshift({ label: 'Draft', value: 'DRAFT', [colorKey]: 'grey' })
      }
      if (!current || current !== 'REJECTED') {
        arr.push({ label: 'Accepted', value: 'ACCEPTED', [colorKey]: 'green' })
      }
      if (!current || current !== 'ACCEPTED') {
        arr.push({ label: 'Rejected', value: 'REJECTED', [colorKey]: 'red' })
      }
      if (withAll) {
        arr.unshift({ value: null, label: 'All Quotations' })
      }
      return arr
    },
    availableQuotationStatuses (currentStatus = null) {
      return this.quotationStatusOptions(false, 'color', currentStatus)
    },
    expiredDaysStr (quotation) {
      return `Expired ${quotation.expired_days} ${this.pluraliseString('day', quotation.expired_days)} ago`
    },
    quotationTermStr (quotation) {
      return `${quotation.expiry_days} day term`
    }
  }
}
